import React, { useEffect, useState } from "react";

// reactstrap components
import {
    // Button,
    // Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
    Button,
    Card,
} from "reactstrap";
import PersonalAccountLayout from 'layouts/PersonalAccountLayout';
import { options_Pays } from "options";
import Select from "react-select";

// core components
import { editPersonalUser } from "network/ApiAxios";
import axios from "axios";
import config from "config";
import useCustomTranslation from "components/Translation/useCustomTranslation";


// const https = require('https');
//
// const agent = new https.Agent({
//     rejectUnauthorized: false,
// });

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async (config) => {
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers['Content-Type'] = "application/json";
    return config;
});

const PersonalAccountParameters = (props) => {
    let user = JSON.parse(localStorage.getItem("user"));
    const { t } = useCustomTranslation();


    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [email, setEmail] = useState(user.email);
    const [isTestUser, setIsTestUser] = useState(false);
    const [phone, setPhone] = useState(user.phone);
    const [description, setDescription] = useState(user.description);
    const [country, setCountry] = useState(user.country);


    useEffect(() => {
        if (JSON.parse(localStorage.getItem("user")).email === "test@test.com") {
            setIsTestUser(true);
        }
    }, []);

    const editUser = async () => {
        // console.log("YYYYYYYYYYYYYYYYYY: personalAccountParameters: editUser: 1 ");
        // console.log("YYYYYYYYYYYYYYYYYY: personalAccountParameters: editUser: firstName: ", firstName);
        // console.log("YYYYYYYYYYYYYYYYYY: personalAccountParameters: editUser: email: ", email)
        const response = await editPersonalUser(
            firstName,
            lastName,
            email,
            country,
        );
        const { data } = response;
        if (!data.success) {

        }
        if (data.success) {
            localStorage.setItem("user", JSON.stringify(data.user[0]));
            window.location.reload();
        }
    };

    return (
        <>
            {(user.role === "user") && (
                <>
                    <PersonalAccountLayout >
                        <Row className='mb-4 mt-2'>
                            <h1>{t`Parameters`}</h1>
                        </Row>

                        <Row>
                            <Row>

                                <Form role="form">


                                    <Row>
                                        <Col lg="3">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-firstName"
                                                >
                                                    {t`firstname`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    value={firstName}
                                                    id="input-firstName"
                                                    // placeholder="Prénom"
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-lastName"
                                                >
                                                    {t`lastname`}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    value={lastName}
                                                    id="input-lastName"
                                                    // placeholder="Nom"
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-email"
                                                >
                                                    Email
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    type="email"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr className="my-4" />


                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-username"
                                                    >
                                                        {t`Country`}
                                                    </label>
                                                    <Select className="w-full "
                                                        options={options_Pays}
                                                        value={country}
                                                        placeholder={country}
                                                        onChange={(e) => {
                                                            setCountry(e.value);
                                                        }} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr className="my-4" />
                                    {/* Description */}

                                </Form>

                            </Row>
                        </Row>

                        <Row>
                            <Button
                                color="primary"
                                // href="#pablo"
                                variant="contained"
                                onClick={editUser}
                                //size="sm"
                                disabled={isTestUser}
                            >
                                {t`Save`}
                            </Button>
                        </Row>

                    </PersonalAccountLayout>
                    {/* <Container>
                        <Row>
                            <Col lg="3">
                            </Col>
                            <Col lg="9">
                                
                            </Col>

                        </Row>
                    </Container> */}
                </>
            )
            }








        </>
    );
};

export default PersonalAccountParameters;
